import React from 'react'
import PropTypes from 'prop-types'
import { Icon, Text, CheckboxField } from '@adc/ui-core'
import smsImage from '../../img/sms.svg'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

export const PHONE_NUMBER_START_RECEIVING = '650-667-7322'
const generateConsentMessage = placement => {
  return `You are signing your written consent to receive communications from Auction.com and its affiliates, including SmartSale, via text and phone (at the number you provided ${placement}) and email, including by using an automated dialer or prerecorded or artificial message, for marketing and commercial purposes. Consent is not a condition of purchase.`
}

export const optInSMSText = {
  title: 'Sign Up to Receive "Action Item Text Alerts"',
  optedInStatusMessage:
    'Look out for Action Item text alerts related to your purchase.',
  optedOutStatusMessage: `You previously opted out of these text alerts. Text START to ${PHONE_NUMBER_START_RECEIVING} to start receiving helpful alerts again.`,
  consentMessageAbove: generateConsentMessage('above'),
  consentMessageBelow: generateConsentMessage('below'),
  benefitsTitle: "You'll Receive Action Items Like These:",
  footerText:
    'You may opt-out and manage your notifications at any time. Message and data rates may apply.',
  benefits: {
    foreclosureOnline: [
      'The property has been cleared for auction.',
      'The Est. Credit Bid has been revealed for your saved property.',
      'Auction is over, yet there are more opportunities to see.',
    ],
    default: [
      "You've Won! Please complete your contract form within 3 hours.",
      "A new auction is about to start with properties similar to ones you've viewed before. Check them out.",
      "You've been outbid. Submit a new bid to get the property you wanted.",
    ],
  },
}

const SMSOptInToggle = ({
  initialOptInStatus,
  optInStatus,
  onCheckBoxClick,
  isForeclosureOnline,
}) => {
  const onChange = () => {
    const newValue = !optInStatus
    onCheckBoxClick(newValue)
  }

  const benefits = isForeclosureOnline
    ? optInSMSText.benefits.foreclosureOnline
    : optInSMSText.benefits.default

  if (initialOptInStatus) {
    return (
      <div className={cx('sms-opted-in', 'u-mt-2')}>
        <Text color='gray' size='tiny'>
          {optInSMSText.optedInStatusMessage}
        </Text>
      </div>
    )
  }
  return (
    <div className={cx('sms-opt-in-container', 'u-mt-2')}>
      <Text color='gray' weight='heavy' className='u-mb-2'>
        {optInSMSText.title}
      </Text>
      {initialOptInStatus === false ? (
        <Text color='caution' size='small' className='u-mb-3'>
          {optInSMSText.optedOutStatusMessage}
        </Text>
      ) : (
        <div className='u-mb-3'>
          <CheckboxField
            checked={Boolean(optInStatus)}
            elmId='sms_opt_in'
            label={
              <Text color='gray' size='tiny'>
                {`By checking this box, ${optInSMSText.consentMessageAbove}`}
              </Text>
            }
            onChange={onChange}
          />
        </div>
      )}
      <div className={cx('sms-benefits-container', 'u-mb-2')}>
        <div className={cx('hide-on-mobile')}>
          <img className={cx('sms-image')} src={smsImage} />
        </div>
        <div>
          <Text color='gray' size='tiny' weight='heavy' className='u-mb-2'>
            {optInSMSText.benefitsTitle}
          </Text>
          {benefits.map((benefitText, idx) => (
            <div
              key={`benifit_text_item_${idx}`}
              className={cx('list-item', 'u-mb-2', 'u-ml-2')}
            >
              <Icon
                data-elm-id={`benifit_text_item_${idx}`}
                name='check-circle'
                size='large'
                color='success'
                iconStyle='solid'
              />
              <Text color='gray' size='tiny'>
                {benefitText}
              </Text>
            </div>
          ))}
        </div>
      </div>
      <Text color='gray' size='tiny'>
        {optInSMSText.footerText}
      </Text>
    </div>
  )
}

SMSOptInToggle.propTypes = {
  optInStatus: PropTypes.bool,
  initialOptInStatus: PropTypes.bool,
  onCheckBoxClick: PropTypes.func,
  isForeclosureOnline: PropTypes.bool,
}

SMSOptInToggle.defaultProps = {
  optInStatus: null,
  onCheckBoxClick: () => {},
  isForeclosureOnline: false,
}

export default SMSOptInToggle
